import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Routes } from 'common/components/Routes';
import { useAuth } from 'auth/hooks';
import { expirationDateIsInFuture } from 'auth/utils';

import { useRefreshTokenMutation } from './graphql/types';

export const App: React.FC = () => {
    const [authenticationCompleted, setAuthenticationCompleted] = useState(
        false
    );
    const { login } = useAuth();
    const [refresh] = useRefreshTokenMutation();
    const {
        i18n: { language },
    } = useTranslation();

    // Persist the user's login state when page is refreshed
    useEffect(() => {
        // If the users previous state was logged in, the refreshExpiresIn variable
        // will be in the local storage
        const refreshExpiresIn = localStorage.getItem('refreshExpiresIn');

        // Don't refresh if invalid refresh token expiration set in localstorage
        if (!refreshExpiresIn || !expirationDateIsInFuture(refreshExpiresIn)) {
            setAuthenticationCompleted(true);

            return;
        }

        (async () => {
            try {
                const { data } = await refresh();

                if (data && data.refreshToken) {
                    const { token, refreshExpiresIn } = data.refreshToken;

                    login(token, refreshExpiresIn);
                }
                setAuthenticationCompleted(true);
            } catch (error) {
                setAuthenticationCompleted(true);
            }
        })();
    }, []);

    // Set page title depending on domain
    useEffect(() => {
        if (language === 'fr') {
            document.title = 'Lunettes de Sociéte';
        }
    }, [language]);

    return authenticationCompleted ? <Routes /> : null;
};
